import React, { useRef, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { QRCodeCanvas } from "qrcode.react";

import { copyToClipboard } from "../../Tables/Paymenthistoryutils";
import { extractLinkCode } from "../../Tables/Paymentlinkutils";
import { COLORS } from "../../Tables/Paymenthistoryconstants";

/**
 * PaymentLinkQrModal – Ödeme linkinin QR kodunu gösterir ve PNG olarak indirir.
 *
 * QR tamamen tarayıcıda üretilir; sunucuya istek atılmaz.
 */
const PaymentLinkQrModal = ({ isOpen, toggle, link }) => {
    const canvasWrapRef = useRef(null);
    const [copied, setCopied] = useState(false);

    if (!link) return null;

    const url = link.paymentLinkUrl || "";
    const code = extractLinkCode(url);

    const handleCopy = async () => {
        await copyToClipboard(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    const handleDownload = () => {
        const canvas = canvasWrapRef.current?.querySelector("canvas");
        if (!canvas) return;

        const a = document.createElement("a");
        a.href = canvas.toDataURL("image/png");
        a.download = `odeme-linki-${code}.png`;
        a.click();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                <i className="bx bx-qr me-2" /> Ödeme Linki QR Kodu
            </ModalHeader>

            <ModalBody>
                <div className="text-center" ref={canvasWrapRef}>
                    {url ? (
                        <QRCodeCanvas value={url} size={220} level="M" includeMargin marginSize={2} />
                    ) : (
                        <div className="text-muted py-4">
                            <i className="bx bx-error-circle display-6 d-block mb-2" />
                            Bu linke ait adres bulunamadı.
                        </div>
                    )}
                </div>

                {url && (
                    <div className="bg-light rounded-4 p-3 mt-3">
                        <div className="text-muted small mb-1">Link Adresi</div>
                        <div className="d-flex align-items-center gap-2">
                            <span
                                className="text-truncate font-monospace small"
                                style={{ flex: "1 1 auto" }}
                                title={url}
                            >
                                {url}
                            </span>
                            <Button color="light" size="sm" className="btn-rounded" onClick={handleCopy} title="Kopyala">
                                <i className={`bx ${copied ? "bx-check text-success" : "bx-copy"}`} />
                            </Button>
                        </div>
                        {link.accountName && (
                            <div className="text-muted small mt-2">
                                <i className="bx bx-id-card me-1" /> {link.accountName}
                            </div>
                        )}
                    </div>
                )}
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Kapat</Button>
                {/* Modal portalı sayfa scope'unun dışında kaldığı için renk inline verilir */}
                <Button
                    onClick={handleDownload}
                    disabled={!url}
                    style={{ background: COLORS.NAVY, borderColor: COLORS.NAVY, color: "#fff" }}
                >
                    <i className="bx bx-download me-1" /> PNG İndir
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PaymentLinkQrModal;
